import { plotArticles } from '@/mocks/animeData';

export default function PlotAnalysis() {
  const [featured, ...rest] = plotArticles;

  return (
    <section id="analysis" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-bold text-primary-700">
              <i className="ri-book-open-line"></i>深度解析
            </span>
            <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">剧情解析</h2>
            <p className="mt-2 text-sm text-foreground-600 md:text-base">
              伏笔、隐喻、结局与暗线，一次讲透不挖坑。
            </p>
          </div>
          <a
            href="#analysis"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-bold text-primary-600 hover:text-primary-700"
          >
            全部解析 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-3">
          <article className="group overflow-hidden rounded-3xl bg-background-100 lg:col-span-2">
            <a href="#analysis" className="grid h-full grid-cols-1 md:grid-cols-2">
              <div className="relative h-52 overflow-hidden md:h-full">
                <img
                  src={featured.image}
                  alt={featured.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-col justify-center p-5 md:p-7">
                <div className="flex items-center gap-2">
                  <span className="rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
                    {featured.tag}
                  </span>
                  <span className="text-xs text-foreground-600">{featured.date}</span>
                </div>
                <h3 className="mt-3 font-heading text-xl leading-snug text-foreground-950 md:text-2xl">
                  {featured.title}
                </h3>
                <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-foreground-600">
                  {featured.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-4 text-xs text-foreground-600">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line"></i>阅读 {featured.readTime}
                  </span>
                  <span className="inline-flex items-center gap-1 text-primary-600">
                    立即阅读 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </a>
          </article>

          <div className="grid grid-cols-1 gap-5">
            {rest.map((a) => (
              <article
                key={a.id}
                className="group flex gap-4 rounded-2xl bg-background-100 p-3 transition-colors hover:bg-background-200/70"
              >
                <div className="h-24 w-24 flex-shrink-0 overflow-hidden rounded-xl md:h-28 md:w-28">
                  <img
                    src={a.image}
                    alt={a.title}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex min-w-0 flex-col justify-center">
                  <div className="flex items-center gap-2">
                    <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-bold text-secondary-900">
                      {a.tag}
                    </span>
                    <span className="text-[11px] text-foreground-600">{a.date}</span>
                  </div>
                  <h3 className="mt-2 line-clamp-2 text-sm font-bold leading-snug text-foreground-950">
                    {a.title}
                  </h3>
                  <div className="mt-2 flex items-center gap-1 text-[11px] text-foreground-600">
                    <i className="ri-time-line"></i>{a.readTime}
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}